// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1w-0 {\n  display: flex;\n  flex-grow: 1;\n  width: 100%;\n  max-width: 200px;\n}\n\n._1w-1 {\n  display: flex;\n  flex-grow: 1;\n  width: 100%;\n}\n\n._1w-2 {\n  display: inline-flex;\n}\n\n._1w-3 {\n  color: var(--redo-colors-text-text-tertiary-600);\n}\n\n._1w-4 {\n  outline: 1px solid var(--redo-colors-border-border-secondary);\n}\n", ""]);
// Exports
export var dropdownButton = "_1w-0";
export var fullWidthDropdownButton = "_1w-1";
export var iconPlaceholder = "_1w-2";
export var icon = "_1w-3";
export var shortcutContainer = "_1w-4";
export default ___CSS_LOADER_EXPORT___;
